import React, { useEffect, useState } from "react";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";

const ConfigModule = ({ title, api, fields }) => {
  const [data, setData] = useState([]);
  const [form, setForm] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [hallOptions, setHallOptions] = useState([]);
  const [isManualName, setIsManualName] = useState(false);

  useEffect(() => {
  const hasMerge = fields.some(f => f.type === "multiselect");

  if (hasMerge) {
    fetch(api)
      .then(res => res.json())
      .then(setHallOptions)
      .catch(console.error);
  }
}, [fields, api]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetch(api);
      const result = await res.json();
      setData(result || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [api]);

 const handleChange = (e) => {
  const { name, value } = e.target;

  // 👇 detect manual name typing
  if (name === "Name") {
    setIsManualName(true);
  }

  setForm((prev) => ({
    ...prev,
    [name]: value,
  }));
};

  const resetForm = () => {
    setForm({});
    setEditingId(null);
  };

  const handleSubmit = async () => {
    setSaving(true);
    try {
      const method = editingId ? "PUT" : "POST";
      const url = editingId ? `${api}/${editingId}` : api;

      await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      resetForm();
      fetchData();
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (item) => {
    setForm({
  ...item,
  childHallIds: item.childHallIds || []
});
    setEditingId(item.Id);
  };

  useEffect(() => {
  if (form.childHallIds?.length > 0 && !isManualName) {
    const selected = hallOptions.filter(h =>
      form.childHallIds.includes(h.Id)
    );

    const name = selected.map(h => h.Name).join(" + ");

    setForm(prev => ({
      ...prev,
      Name: name
    }));
  }
}, [form.childHallIds, isManualName]);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this item?")) return;
    await fetch(`${api}/${id}`, { method: "DELETE" });
    fetchData();
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border p-5">
      {/* HEADER */}
      <div className="mb-4">
        <h3 className="text-2xl font-bold mb-4 text-center border-b pb-2">{title}</h3>
      </div>

      {/* FORM */}
      <div className="flex flex-wrap gap-3 mb-5">
                       {fields.map((f) => {
  // ✅ MERGE HALLS (checkbox)
  if (f.type === "multiselect") {
    return (
      <div key={f.name} className="flex flex-col">
        <label className="text-xs text-gray-500 mb-1">{f.label}</label>

       <div className="border rounded-md p-2 flex flex-wrap gap-3 w-[260px]">
          {hallOptions
            .filter(h => h.Id !== form.Id)
            .map(h => (
              <label key={h.Id} className="flex items-center gap-2 text-sm">
                <input
                  type="checkbox"
                  checked={form.childHallIds?.includes(h.Id) || false}
                  onChange={(e) => {
                    let updated = form.childHallIds || [];

                    if (e.target.checked) {
                      updated = [...updated, h.Id];
                    } else {
                      updated = updated.filter(id => id !== h.Id);
                    }

                    setForm(prev => ({
                      ...prev,
                      childHallIds: updated
                    }));
                  }}
                />
                {h.Name}
              </label>
            ))}
        </div>
      </div>
    );
  }

  // ✅ NORMAL INPUT
  return (
    <input
      key={f.name}
      name={f.name}
      placeholder={f.label}
      value={form[f.name] || ""}
      onChange={handleChange}
      // disabled={
      //   f.name === "Name" && form.childHallIds?.length > 0
      // }
      className="border rounded-md px-3 py-2 text-sm w-[160px]"
    />
  );
})}

        <button
          onClick={handleSubmit}
          disabled={saving}
          className="flex items-center gap-2 bg-teal-600 text-white px-4 py-2 rounded-md text-sm hover:bg-teal-700 transition"
        >
          <FaPlus size={12} />
          {saving ? "Saving..." : editingId ? "Update" : "Add"}
        </button>

        {editingId && (
          <button
            onClick={resetForm}
            className="px-3 py-2 text-sm bg-gray-100 rounded-md hover:bg-gray-200"
          >
            Cancel
          </button>
        )}
      </div>

      {/* TABLE */}
      <div className="overflow-x-auto">
        {loading ? (
          <div className="text-center text-gray-500 py-4">Loading...</div>
        ) : data.length === 0 ? (
          <div className="text-center text-gray-400 py-4">
            No data found
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-gray-500 border-b">
                {/* {fields.map((f) => {
  // ✅ MERGE HALLS (checkbox)
  if (f.type === "multiselect") {
    return (
      <div key={f.name} className="flex flex-col">
        <label className="text-xs text-gray-500 mb-1">{f.label}</label>

        <div className="border rounded-md p-2 w-[180px] max-h-[120px] overflow-auto">
          {hallOptions
            .filter(h => h.Id !== form.Id)
            .map(h => (
              <label key={h.Id} className="flex items-center gap-2 text-sm">
                <input
                  type="checkbox"
                  checked={form.childHallIds?.includes(h.Id) || false}
                  onChange={(e) => {
                    let updated = form.childHallIds || [];

                    if (e.target.checked) {
                      updated = [...updated, h.Id];
                    } else {
                      updated = updated.filter(id => id !== h.Id);
                    }

                    setForm(prev => ({
                      ...prev,
                      childHallIds: updated
                    }));
                  }}
                />
                {h.Name}
              </label>
            ))}
        </div>
      </div>
    );
  }

  // ✅ NORMAL INPUT
  return (
    <input
      key={f.name}
      name={f.name}
      placeholder={f.label}
      value={form[f.name] || ""}
      onChange={handleChange}
      disabled={
        f.name === "Name" && form.childHallIds?.length > 0
      }
      className="border rounded-md px-3 py-2 text-sm w-[160px]"
    />
  );
})} */}
                <th className="text-center py-2">Actions</th>
              </tr>
            </thead>

            <tbody>
              {data.map((item, i) => (
                <tr
                  key={item.Id}
                  className={`border-b hover:bg-gray-50 ${
                    i % 2 ? "bg-gray-50/40" : ""
                  }`}
                >
                  {fields.map((f) => (
                    <td key={f.name} className="py-2">
                      {f.type === "multiselect"
  ? hallOptions
      .filter(h => item.childHallIds?.includes(h.Id))
      .map(h => h.Name)
      .join(" + ") || "Single"
  : item[f.name]}
                    </td>
                  ))}

                  <td className="flex justify-center gap-3 py-2">
                    <FaEdit
                      className="text-blue-500 cursor-pointer"
                      onClick={() => handleEdit(item)}
                    />
                    <FaTrash
                      className="text-red-500 cursor-pointer"
                      onClick={() => handleDelete(item.Id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default ConfigModule;